<ic-ui-card
	class="small-header"
	loadingText="{{ 'general.fetching' | translate }} {{ 'general.titles.tasksgraphics' | translate | lowercase }}"
>
	<header>
		<pv-title>
			<ic-fa-icon icon="pie-chart"> </ic-fa-icon>
			<h1>{{ 'general.titles.tasksgraphics' | translate }}</h1>
		</pv-title>

		@if (!dateInput() && canViewTaskStatisticsWidget()) {
			<ic-date-filter class="top right align-right full-horizontal" (date)="date.set($event)"> </ic-date-filter>
		}
	</header>

	<section>
		@if (statisticsQuery?.isLoading()) {
			<spinner></spinner>
		} @else {
			@if (canViewTaskStatisticsWidget() && !statisticsQuery?.isLoading()) {
				<ic-task-statistics
					data-test="task-overview-card"
					[statistics]="graphStatistics()"
					[completed]="completed()"
				></ic-task-statistics>
			} @else {
				<p
					data-test="task-overview-no-permission-message"
					class="ic-block small full-width text-center text-surface-500 py-8"
				>
					{{ 'general.no_permissions' | translate }}
				</p>
			}
		}
	</section>
</ic-ui-card>
